<template>
  <vx-card :title="title">
    <vs-button
      class="mt-2"
      color="primary"
      type="border"
      icon-pack="feather"
      icon="icon-plus"
      @click="handleCreate()"
      >Create</vs-button
    >
    <div class="vx-row mb-12">
      <div v-bind:class="[detail ? detailShow : '', detailHide]">
        <vs-table
          search
          stripe
          border
          description
          :sst="true"
          :data="table.data"
          :max-items="table.length"
          :total="table.total"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
        >
          <template slot="header">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ this.table.start }} - {{ this.table.end }} of
                  {{ this.table.total }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="item in table.limits"
                  :key="item"
                  @click="handleChangelength(item)"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
          <template slot="thead">
            <vs-th width="5%"></vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="type">Type</vs-th>
            <vs-th>Customer Cluster</vs-th>
            <vs-th sort-key="is_active">Status</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  title="Edit"
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="ml-2"
                  @click.stop="handleEdit(data[indextr].id)"
                />
              </vs-td>
              <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
              <vs-td :data="data[indextr].type">
                <span
                  style="
                    display: inline-block;
                    background: #ede9ff;
                    color: #7367f0;
                    font-weight: 600;
                    font-size: 0.8rem;
                    padding: 2px 10px;
                    border-radius: 20px;
                  "
                >
                  {{ data[indextr].type }}
                </span>
              </vs-td>
              <vs-td
                :data="data[indextr].customer_cluster"
                style="min-width: 220px; max-width: 300px"
              >
                <div
                  v-if="
                    data[indextr].customer_cluster &&
                    data[indextr].customer_cluster.length > 0
                  "
                  class="customer-cluster-list"
                >
                  <div
                    v-for="c in data[indextr].customer_cluster"
                    :key="c.customer_id"
                    class="customer-cluster-item"
                  >
                    <span class="cluster-code-badge">{{
                      c.customer_code
                    }}</span>
                    <span class="cluster-name">{{ c.customer_name }}</span>
                  </div>
                </div>
                <span v-else class="no-customer-text">— No customers</span>
              </vs-td>
              <vs-td :data="data[indextr].is_active">
                <span
                  :style="
                    data[indextr].is_active
                      ? 'display:inline-flex;align-items:center;gap:5px;background:#e8f8f0;color:#28c76f;font-weight:600;font-size:0.78rem;padding:3px 12px;border-radius:20px;'
                      : 'display:inline-flex;align-items:center;gap:5px;background:#fff0f0;color:#ea5455;font-weight:600;font-size:0.78rem;padding:3px 12px;border-radius:20px;'
                  "
                >
                  <span
                    style="
                      width: 7px;
                      height: 7px;
                      border-radius: 50%;
                      background: currentColor;
                      display: inline-block;
                    "
                  ></span>
                  {{ data[indextr].is_active ? "Active" : "Inactive" }}
                </span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination
          style="padding-top: 5px"
          :total="table.totalPage"
          v-model="setPage"
        />
      </div>
      <!-- form -->
      <transition name="detail-fade">
        <div
          v-if="detail"
          v-bind:class="[detail ? detailShow : '', detailHide]"
        >
          <vs-row>
            <vs-col
              class="vertical-divider"
              vs-offset="0"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="1"
            >
            </vs-col>

            <!-- form component -->
            <vs-col vs-w="11" style="padding: 0 8px">
              <form-component
                @close="handleClose"
                :id="id"
                :url="baseUrl"
                :title="title"
                :isDefault="isDefault"
              ></form-component>
            </vs-col>
          </vs-row>
        </div>
      </transition>
    </div>
  </vx-card>
</template>
<script>
import FormComponent from "./form";
export default {
  components: {
    FormComponent,
  },
  data() {
    return {
      title: "Customer Group Cluster",
      baseUrl: "/api/v1/master/customer-group-clusters",
      detailShow: "core vx-col md:w-1/2 w-full mb-base ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      detail: false,
      deleteId: null,
      id: null,
      isDefault: 0,
      table: this.tableDefaultState(),
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.detail = false;
    },
    handleCreate() {
      this.id = null;
      this.detail = true;
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl, {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;
            this.setStartEnd();
            this.$vs.loading.close();
            var _this = this;
            resp.data.records.forEach(function (element) {
              if (element.IsDefault == 1) {
                _this.isDefault = element.id;
              }
            });
          } else {
            console.log(resp.data);
          }
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }
      if (this.table.totalSearch < this.table.total) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleDelete(id) {
      this.deleteId = id;
      if (id == this.isDefault) {
        this.$vs.dialog({
          type: "alert",
          color: "danger",
          title: `Information`,
          text: "This customer group cluster is set to default, you can't delete this.",
        });
      } else {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: `Confirm`,
          text: "Please confirm to delete this data",
          accept: this.acceptDelete,
        });
      }
    },
    handleEdit(id) {
      this.id = parseInt(id);
      this.detail = true;
    },
  },
  watch: {},
  mounted() {},
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>

<style scoped>
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}
.customer-cluster-list {
  max-height: 120px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 4px;
}
.customer-cluster-list::-webkit-scrollbar {
  width: 4px;
}
.customer-cluster-list::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}
.customer-cluster-list::-webkit-scrollbar-thumb {
  background: #c5bef5;
  border-radius: 4px;
}
.customer-cluster-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 0;
  border-bottom: 1px solid #f5f5f5;
  font-size: 0.8rem;
}
.customer-cluster-item:last-child {
  border-bottom: none;
}
.cluster-code-badge {
  display: inline-block;
  background: #ede9ff;
  color: #7367f0;
  font-weight: 600;
  font-size: 0.72rem;
  padding: 1px 7px;
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
}
.cluster-name {
  color: #555;
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.no-customer-text {
  color: #ccc;
  font-size: 0.82rem;
}
</style>
